export default {
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    getMutationBasedOnKey(actionName) {
      switch (actionName) {
        case "getSitesV3":
          return "SET_SITES";
        case "getSitesUpdatesV3":
          return "UPDATE_SITES_UPDATES";
        case "getPluginsAndThemesV3":
          return "UPDATE_PLUGINS_AND_THEMES";
        case "getGroupsSitesV3":
          return "SET_GROUPS";
        case "getClientUpdateAvailableSiteIDs":
          return "SET_CLIENT_PLUGIN_UPDATES";
        case "getHistoryPanelHTMLV3":
          return "SET_PANEL_HISTORY";
        default:
          return null;
      }
    },
    loadAddon(addonSlug) {
      switch (addonSlug) {
        case "googleAnalytics":
          return import(/* webpackChunkName: 'googleAnalytics/index' */ "@/components/addons/GoogleAnalytics/index");
        case "backupRepository":
          return import(/* webpackChunkName: 'backupRepository/index' */ "@/components/addons/BackupRepository/index");
        case "installClone":
          return import(/* webpackChunkName: 'installClone/index' */ "@/components/addons/InstallClone/index");
        case "scheduleBackup":
          return import(/* webpackChunkName: 'scheduleBackup/index' */ "@/components/addons/ScheduleBackup/index");
        case "ithemesSecurity":
          return import(/* webpackChunkName: 'ithemesSecurity/index' */ "@/components/addons/IthemesSecurity/index");
        case "malwareScanningSucuri":
          return import(/* webpackChunkName: 'malwareScanningSucuri/index' */ "@/components/addons/MalwareScanningSucuri/index");
        case "wordFence":
          return import(/* webpackChunkName: 'wordFence/index' */ "@/components/addons/WordFence/index");
        case "manageComments":
         return import(/*  webpackChunkName: 'manageComments/index' */ "@/components/addons/ManageComments/index");  
        case "manageUsers":
          return import(/* webpackChunkName: 'manageUsers/index' */ "@/components/addons/ManageUsers/index");
        case "brokenLinks":
        return import(/* webpackChunkName: 'brokenLinks/index' */ "@/components/addons/BrokenLinks/index");
        case "WPTC":
        return import(/* webpackChunkName: 'WPTC/index' */ "@/components/addons/WPTC/index");    
        case "wpOptimize":
        return import(/* webpackChunkName: 'WPOptimize/index' */ "@/components/addons/WPOptimize/index"); 
        case "googleSafeBrowsing":
        return import(/* webpackChunkName: 'googleSafeBrowsing/index' */ "@/components/addons/GoogleSafeBrowsing/index");
        case "googlepagespeed":
        return import(/* webpackChunkName: 'googlePageSpeed/index' */ "@/components/addons/GooglePageSpeed/index");
        case "codeSnippets":
          return import(/* webpackChunkName: 'codeSnippets/index' */ "@/components/addons/CodeSnippets/index");  
        case "fileEditor":
          return import(/* webpackChunkName: 'fileEditor/index' */ "@/components/addons/FileEditor/index"); 
        case "upTimeMonitor":
          return import(/* webpackChunkName: 'upTimeMonitor/index' */ "@/components/addons/UptimeMonitorUptimeRobot/index");  
        case "clientReporting":
          return import(/* webpackChunkName: 'clientReporting/index' */ "@/components/addons/ClientReporting/index");    
        case "multiUser":
          return import(/* webpackChunkName: 'multiUser/index' */ "@/components/addons/MultiUser/index");
        case "bulkPublish":
          return import(/* webpackChunkName: 'BulkPublish/index' */ "@/components/addons/BulkPublish/index");          
        default:
          return Promise.resolve("addon_not_supported");
      }
    }
  }
};


